import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      fill={props.fill || "#5C6267"}
      d="M2.667 8.714h6.666a.68.68 0 0 1 .472.189c.125.12.195.284.195.454 0 .17-.07.334-.195.455a.68.68 0 0 1-.472.188H2.667a.68.68 0 0 1-.472-.188A.631.631 0 0 1 2 9.357c0-.17.07-.334.195-.454a.68.68 0 0 1 .472-.189Zm6.862-6.013-.706.68-1.568-1.513.705-.68A.68.68 0 0 1 8.431 1a.68.68 0 0 1 .472.188l.626.604c.125.12.195.284.195.454 0 .17-.07.334-.195.455ZM8.43 3.759 4.235 7.805H2.667V6.293l4.196-4.047L8.43 3.76Z"
    />
  </svg>
);
export default SvgComponent;
